import { GraphArt } from './GraphArt';

/**
 * "Brand Split" navy panel (Type A). Deliberately wordless: the gradient,
 * glow, grid and knowledge-graph line art only, pending the approved visual for
 * the left half. Every string it used to carry — the wordmark, headline,
 * subtitle, feature bullets and copyright — was removed together, so the panel
 * is now decoration and is hidden from assistive tech; the right pane carries
 * the whole accessible name of the page. Hidden below `lg`, where the form
 * fills the screen.
 */
export function BrandPanel() {
  return (
    <div
      aria-hidden="true"
      className="relative hidden overflow-hidden bg-[hsl(212_75%_9%)] lg:block"
    >
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[hsl(205_100%_17%)] via-[hsl(210_95%_20%)] to-[hsl(214_80%_8%)]" />
      <div className="pointer-events-none absolute -left-24 top-[-10%] h-[32rem] w-[32rem] rounded-full bg-[radial-gradient(circle,hsl(212_100%_60%/0.4),transparent_65%)] blur-2xl" />
      <div className="pointer-events-none absolute -bottom-32 right-[-10%] h-[30rem] w-[30rem] rounded-full bg-[radial-gradient(circle,hsl(190_95%_55%/0.25),transparent_65%)] blur-3xl" />
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(hsl(0_0%_100%/0.05)_1px,transparent_1px),linear-gradient(90deg,hsl(0_0%_100%/0.05)_1px,transparent_1px)] [background-size:44px_44px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]" />
      <div className="pointer-events-none absolute -right-16 -top-16 h-[26rem] w-[26rem] opacity-90 [filter:drop-shadow(0_0_10px_hsl(212_100%_65%/0.5))]">
        <GraphArt className="h-full w-full" />
      </div>
    </div>
  );
}
